import React from 'react';
import PropTypes from 'prop-types';


const CategoryGrid = function CategoryGridComponent({ categories }) {
  return categories.map(category => (
    <div
      key={category.id}
      className="homepage-category__wrapper"
    >
      <a
        href={category.url}
        className="homepage-category--compact"
        aria-label={`Shop ${category.name}`}
      >
        <span className="homepage-category__title-compact">
          {category.name}
        </span>
      </a>
    </div>
  ));
};

export default CategoryGrid;

CategoryGrid.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })).isRequired,
};
